export const ServerConfig = { 
    baseUrl: process.env.REACT_APP_API_URL
}